import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';

export default class HeaderComp extends Component {
    
    constructor(){
		super()
		this.state = {
			open:false,
		}
		this.handleToggle 		= this.handleToggle.bind(this);
		this.handleMouseOver 	= this.handleMouseOver.bind(this);
		this.handleMouseOut 	= this.handleMouseOut.bind(this);
	}
    
    handleToggle() {  
	    if (document.body.classList.contains('state-enquire-open')) {
		    document.body.classList.remove('state-enquire-open');
	    } else if (document.body.classList.contains('state-menu-open')) {
		    document.body.classList.remove('state-menu-open');
	    } else {
		    document.body.classList.add('state-menu-open');
	    }
    }
    
    handleEnquire() {  
	    document.body.classList.remove('state-menu-open');
	    document.body.classList.add('state-enquire-open');
	    document.getElementById('input_11_6').readOnly = false;
	    document.getElementById('input_11_6').value = "General Enquiry";
	    var event = new Event('blur');
	    document.getElementById('input_11_6').dispatchEvent(event);
		document.getElementById('input_11_6').readOnly = true;
    }
    
    handleMouseOver() {  
	    if (document.getElementsByClassName('c-header__menu__small-list')[0].offsetParent === null && document.documentElement.classList.contains('state-no-touch')) {
		    document.body.classList.add('state-menu-open');
	    }
    }
    
    handleMouseOut() {  
	    if (document.getElementsByClassName('c-header__menu__small-list')[0].offsetParent === null && document.documentElement.classList.contains('state-no-touch')) {
		    document.body.classList.remove('state-menu-open');
	    }
    }
    
	render () {
		
		let menu = this.props.menu;
		
		if (menu) {
			
		    return (
		        
		        <header className="c-header">
		    		<div className="c-header__background"></div>
		    		<h2 className="c-header__logo">
		    		
		    			<Link to={{ pathname: '/' }} className="c-header__logo__inner">
		    				<svg viewBox="0 0 319 42">
								<path d="m50.43 40.98h15.67v-3.87h-15.67v3.87zm-8.14 0h7.15v-39.96h-7.15v39.96zm-24.14-6.88 2.06 6.87 12.39-39.95h-4.61l-9.84 33.08zm73.35-15.93-3.53-0.9c-2.76-0.71-4.7-1.58-5.74-2.59-1.03-0.98-1.55-2.48-1.55-4.44 0-2.13 0.65-3.79 1.93-4.95 1.29-1.16 3.17-1.75 5.61-1.75 2.25 0 4.06 0.81 5.39 2.4 1.22 1.47 1.98 3.59 2.26 6.31l0.03 0.27h5.32l0.7-0.09-0.04-0.3c-0.52-3.99-1.92-7.01-4.14-8.95-2.23-1.94-5.43-2.93-9.51-2.93-4.38 0-7.76 1-10.05 2.96-2.31 1.98-3.48 4.91-3.48 8.7 0 3.31 0.79 5.92 2.35 7.74 1.55 1.82 4.3 3.24 8.15 4.24l3.28 0.84c2.07 0.51 3.65 1.05 4.71 1.61 1.03 0.54 1.78 1.23 2.22 2.03 0.44 0.81 0.67 1.91 0.67 3.26 0 4.55-2.63 6.76-8.05 6.76-2.38 0-4.29-0.81-5.68-2.4-1.21-1.39-2.03-3.38-2.45-5.92l-0.04-0.25h-5.92l0.04 0.34c0.51 3.86 1.9 6.78 4.13 8.67 2.29 1.94 5.63 2.93 9.92 2.93 4.5 0 8.02-1.02 10.46-3.02 2.46-2.02 3.71-4.95 3.71-8.71 0-3.19-0.83-5.72-2.45-7.52-1.63-1.8-4.4-3.25-8.25-4.34zm221.25-17.73c-3.62 0-6.08 2.74-6.08 6.08 0 3.36 2.46 6.08 6.08 6.08 3.64 0 6.08-2.72 6.08-6.08 0-3.34-2.44-6.08-6.08-6.08zm0 11.04c-2.95 0-4.84-2.03-4.84-4.96s1.89-4.96 4.84-4.96 4.86 2.03 4.86 4.96-1.91 4.96-4.86 4.96zm-204.74-6.59h10.53v36.09h7.15v-36.09h10.4v-3.87h-28.08v3.87zm-43.06-3.87h-14.52v3.87h14.52v-3.87zm-1.35 17.59h-13.17v4h13.17v-4zm-63.43-17.59 12.45 39.96h6.54l-11.86-39.96h-7.13zm296.96 2.56c-2.42-1.7-5.81-2.56-10.09-2.56h-5.8v3.04h5.03c3.93 0 6.52 1.42 7.92 4.36 1.41 2.96 2.12 7.2 2.12 12.62 0 5.37-0.72 9.59-2.12 12.55-1.39 2.93-3.98 4.35-7.92 4.35h-5.03v3.04h5.8c4.28 0 7.68-0.86 10.09-2.56 2.42-1.7 4.11-4.03 5.03-6.93 0.9-2.86 1.36-6.38 1.36-10.46s-0.46-7.6-1.36-10.49c-0.92-2.92-2.61-5.26-5.03-6.96zm-23.71 37.4h6.83v-39.96h-6.83v39.96zm41.89-35.38c0-1.22-0.81-2.05-2.49-2.05h-2.23v5.97h1.15v-1.87h1.01c0.16 0 0.39-0.02 0.39-0.02l0.92 1.89h1.34l-1.15-2.14c0.71-0.35 1.06-0.97 1.06-1.78zm-2.33 0.94h-1.24v-1.91h1.24c0.74 0 1.15 0.37 1.15 0.97s-0.42 0.94-1.15 0.94zm-62.05-5.52h-7.15v39.96h20.89v-3.87h-13.74v-36.09zm-86.5 19.2c1.73-0.82 3-1.95 3.8-3.37 0.9-1.6 1.36-3.43 1.36-5.44 0-3.11-1.01-5.65-3.02-7.54-2-1.89-5.3-2.84-9.8-2.84h-4.42v3.04h3.97c2.04 0 3.58 0.62 4.59 1.85 1.02 1.25 1.54 3.12 1.54 5.56 0 2.28-0.48 4.14-1.43 5.51-0.92 1.34-2.5 2.02-4.7 2.02h-3.97v3.04h5.64c2.05 0 3.57 0.76 4.63 2.31 1.07 1.57 1.62 3.52 1.62 5.8 0 5.24-2.04 7.79-6.25 7.79h-5.64v3.04h6.28c4.6 0 7.92-1.04 9.85-3.08s2.91-4.64 2.91-7.75c0-2.32-0.62-4.43-1.85-6.27-1.12-1.67-2.83-2.9-5.11-3.67zm-20.16 20.76h7.07v-39.96h-7.07v39.96zm79.32 0h7.15v-39.96h-7.15v39.96zm-17.34-13.33c0 3.49-0.93 6.11-2.76 7.77-1.84 1.67-4.11 2.52-6.76 2.52-2.56 0-4.61-0.82-6.11-2.44s-2.26-4.27-2.26-7.85v-26.63h-7.15v26.63c0 5.04 1.45 8.7 4.32 10.86 2.85 2.15 6.46 3.24 10.74 3.24 2.38 0 4.68-0.45 6.83-1.34 2.16-0.89 3.98-2.42 5.4-4.54s2.14-4.88 2.14-8.22v-26.63h-4.39v26.63z" fill="#fff"/>
							</svg>
		    			</Link>
		    		</h2>
		    		<a href="#" className="c-header__menu-button" onClick={(e) => (e.preventDefault(), this.handleToggle())} onMouseOver={(e) => (e.preventDefault(), this.handleMouseOver())} onMouseOut={(e) => (e.preventDefault(), this.handleMouseOut())}><span>Menu</span><span>Close</span></a>
		    		{menu.json.vconnect_url &&
			    		<a href={menu.json.vconnect_url} className="c-header__v-button">VConnect</a>
		    		}
		    		
		    		<div className="c-header__menu" onMouseOver={(e) => (e.preventDefault(), this.handleMouseOver())} onMouseOut={(e) => (e.preventDefault(), this.handleMouseOut())}>
		    			<div className="c-header__menu__inner">
			    			<ul className="c-header__menu__list">
			    				{menu.json.item.map((item,i) => 
				        			{		
					        			if (item.title == 'Enquire') {	        			
						        			return (
							        			<li className="c-header__menu__item" key={i}>
								        			<a href="#" onClick={(e) => (e.preventDefault(), this.handleEnquire())} className="c-header__menu__link" dangerouslySetInnerHTML={{__html:item.title}}></a>
												</li>
											)
										} else if (item.title == 'Contact') {	        			
						        			return (
							        			<>
								        			{menu.json.vconnect_url &&
								        				<li className="c-header__menu__item c-header__menu__item--mobile" key={100}>
								        					<a href={menu.json.vconnect_url} className="c-header__menu__link" dangerouslySetInnerHTML={{__html:'VConnect'}}></a>
														</li>
													}
								        			<li className="c-header__menu__item" key={i}>
								        				<Link to={{ pathname: item.url }} className="c-header__menu__link" dangerouslySetInnerHTML={{__html:item.title}}></Link>
													</li>
												</>
											)
										} else {
											return (
							        			<li className="c-header__menu__item" key={i}>
							        				<Link to={{ pathname: item.url }} className="c-header__menu__link" dangerouslySetInnerHTML={{__html:item.title}}></Link>
												</li>
											)
										}
					        		}
					        	)}
			    			</ul>
			    			<ul className="c-header__menu__small-list">
								{menu.json.disclaimer_url &&		    				
				        			<li className="c-header__menu__small-item">
				        				<Link to={{ pathname: menu.json.disclaimer_url }} className="c-header__menu__link" dangerouslySetInnerHTML={{__html:'Disclaimer'}}></Link>
									</li>
								}
								{menu.json.privacy_policy_url &&		    				
				        			<li className="c-header__menu__small-item">
				        				<Link to={{ pathname: menu.json.privacy_policy_url }} className="c-header__menu__link" dangerouslySetInnerHTML={{__html:'Privacy Policy'}}></Link>
									</li>
								}
								<li className="c-header__menu__small-item" dangerouslySetInnerHTML={{__html:'© Vestbuild 2021'}}></li>
			    			</ul>
			    		</div>
		    		</div>
				</header>	
			        	
			)
			
		} else {
			
			return null;
		
		}
	}
}
